import InfoLabel, { InfoLabelProps } from "./InfoLabel";
import classes from "../../styles/InfoLabel.module.css";
import { useTexts } from "../../hooks";

type FreeRoundsLabelProps = InfoLabelProps & { value: string | number };

const FreeRoundsLabel: React.FC<FreeRoundsLabelProps> = (props) => {
  const { visible, direction, shape, value } = props;
  const { common } = useTexts();

  return (
    <InfoLabel className={classes["free-rounds"]} shape={shape} direction={direction} visible={visible}>
      <div className="color text-white">{common.freerounds}:</div>
      <div className="color text-yellow currency"> {value} </div>
    </InfoLabel>
  );
};

export default FreeRoundsLabel;
